module.exports = __webpack_public_path__ + "img/receipt.54a015dc.svg";